export const VirtualQRDetails = {
    GET_VIRTUALQRDATADETAILS: "GET_VIRTUALQRDATADETAILS",
    PUT_ASSIGNVIRTUALWITHQR: "PUT_ASSIGNVIRTUALWITHQR"
    

}
